import { render, staticRenderFns } from "./dilu-ue.vue?vue&type=template&id=44529064&"
import script from "./dilu-ue.vue?vue&type=script&lang=js&"
export * from "./dilu-ue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports